module.exports = __webpack_public_path__ + "static/1203599923-wide.a16fd5fe.jpg";